import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  addtripModalShow: false,
  addbookingModalShow: false,
  bookingMealData: {
    mealName: '',
    resName: '',
    price: '',
    id: '',
    mealoffereds: '',
    locations: '',
    format: '',
  },
};

const mealSlice = createSlice({
  name: 'mealSlice',
  initialState,
  reducers: {
    // Action to show the Add Trip modal
    addTripModalShow(state) {
      return { ...state, addtripModalShow: true }; // Create a new state with the updated value
    },
    // Action to hide the Add Trip modal
    addTripModalHide(state) {
      return { ...state, addtripModalShow: false }; // Create a new state with the updated value
    },
    // Action to show the Add Booking modal
    addBookingModalShow(state, action) {
      return {
        ...state,
        addbookingModalShow: true,
        bookingMealData: action.payload, // Set the meal data from the payload
      };
    },
    // Action to set meal data for booking
    mealDataForBooking(state, action) {
      return { ...state, bookingMealData: action.payload }; // Create a new state with the updated meal data
    },
    // Action to hide the Add Booking modal
    addBookingModalHide(state) {
      return { 
        ...state,
        addbookingModalShow: false,
        bookingMealData: initialState.bookingMealData, // Reset the meal data
      };
    },
  },
});

// Export actions
export const {
  addTripModalShow,
  addTripModalHide,
  addBookingModalShow,
  mealDataForBooking,
  addBookingModalHide,
} = mealSlice.actions;

// Export reducer
export default mealSlice.reducer;
